module.exports = __webpack_public_path__ + "img/image-5-p-500.dfc61ca4.png";